let React               = require("react");

let ContentServerClient = require("../../ContentServerClient.js");
let HubsUtil            = require("../../util/HubsUtil.js");
let Avatar              = require("../Avatar.jsx");
let Dropdown            = require("../buttons/generic/Dropdown.jsx");
let LoadingPlaceholder            = require("../cards/LoadingPlaceholder.jsx");

class CoverHub extends React.Component {

    constructor(){
        super();
        this.state = {
            manageMembersModalTriggered: false
        };

        this.callOpen = this.callOpen.bind(this);
        this.onHubSelected = this.onHubSelected.bind(this);
    }

    onHubSelected(id, name){
        let encodedName = encodeURIComponent(name);
        this.props.history.push(`/hubs/${id}-${encodedName}/libraries`);
    }

    getSelect(allHubs){
        let { currentHub, allowedNumberOfHubs, currentNumberOfHubs, onOpen, typeUser } = this.props;

        let elements = allHubs.map((hub) => (
            {
                name: hub.name,
                tootip: hub.name,
                selected: (currentHub)? currentHub.id === hub.id :  false,
                className: hub.deleted ? "--removed": "",
                onClick: (() => this.onHubSelected(hub.id, hub.name)),
                badge: <span className="typeUser">
                        { HubsUtil.isOwner(hub) && !hub.deleted && "Owner" }
                        { !HubsUtil.isOwner(hub) && !hub.deleted && "Member" }
                        { hub.deleted && "Deleted" }
                       </span>
            }
        ));

        let modal = "create";
        if(typeUser === "free" && currentNumberOfHubs >= allowedNumberOfHubs){
            modal = "subscribe";
        }

        let options = [...elements, {name: "Create New", onClick: () => onOpen(modal)}]

        return <Dropdown name={`Change ${hubAlias}`} options={options}/>
    }

    formatMembers(members){
        return members.reduce((accum, {id, avatar}, index) => {
                                if(index < 3){
                                    return [...accum, <Avatar key={id} url={avatar}/>];
                                }else if(members.length === (index + 1)){
                                    return [...accum, <Avatar key={id} type="text" letters={`+${members.length-3}`} style="numberMembers" onClick={() => this.props.onOpen("manage")}/>];
                                } return accum;
                            }, []);
    }

    callOpen(isOwner) {
        if(isOwner){
            this.props.onOpen("manage")
        }else{
            this.props.onOpen("manage", {isView: true})
        }
    }

    sortElements(data){
        return [...data].sort((x,y) => x.name.localeCompare(y.name))
    }

    render() {
        let { loadingHubName,
            currentHub,
            currentHubMembers,
            myHubs,
            memberHubs,
            trashHubs,
            errorListHubs,
            allowedNumberOfHubs,
            currentNumberOfHubs,
            onOpen,
            location } = this.props;

        let isOwner = false;
        let isDeleted = false;

        let allHubs = null;
        if(myHubs  && memberHubs && trashHubs){
            allHubs = this.sortElements(myHubs)
                            .concat(this.sortElements(memberHubs))
                            .concat(this.sortElements(trashHubs));
        }

        if(currentHub){
            isOwner = HubsUtil.isOwner(currentHub);
            isDeleted = currentHub.deleted;
        }

        let doneLoading = (allHubs && currentHubMembers);
        if ( doneLoading && location.search === "?manageMembers=true" && !this.state.manageMembersModalCalled) {
            this.callOpen(isOwner);
            this.setState({ manageMembersModalCalled: true });
        }

        const OptionsHub = () => {
            if(!allHubs){
                return null
            }else if(allHubs.length >= 2){
                return this.getSelect(allHubs, isOwner);
            }else{
                return <button className="button" onClick={() => onOpen(currentNumberOfHubs >= allowedNumberOfHubs ? "subscribe": "create")}>New {fullHubAlias}</button>
            }
        }

        return  <section className="coverHub">
                    <div className="container">
                        <div className="coverHub__options">
                            <div className="coverHub__options__settings">
                                { currentHub &&
                                    <React.Fragment>
                                      <svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                          <use xlinkHref='#MFolder' />
                                      </svg>
                                      <h2> {currentHub.name} </h2>
                                    </React.Fragment>
                                }

                                { !currentHub && !errorListHubs && !allHubs &&
                                    <h2> {loadingHubName || "Loading..."} </h2>
                                }

                                { currentHub && isOwner && !isDeleted &&
                                    <div className="coverHub__options__settings__icon" onClick={() => onOpen("update")}></div>
                                }

                                { currentHub &&
                                    <div className="coverHub__options__settings__typeUser">
                                        {!isDeleted && (isOwner ? "Owner": "Member")}
                                        { isDeleted && "Deleted"}
                                    </div>
                                }
                            </div>


                            <div className="coverHub__options__members">
                                <React.Fragment>
                                    {  currentHubMembers && !isDeleted &&
                                        <button className="coverHub__options__members__manage button" onClick={()=>this.callOpen(isOwner)}>
                                                {isOwner ? "Manage Members": "View Members"}
                                        </button>
                                    }
                                    { currentHubMembers &&
                                        <div className="coverHub__options__members__avatars">
                                            <Avatar url={currentHub.owner.avatar}/>
                                            {this.formatMembers(currentHubMembers)}
                                        </div>
                                    }
                                </React.Fragment>

                            </div>

                        </div>

                        <div className="coverHub__new">
                            { allHubs &&
                                <OptionsHub/>
                            }
                            { !allHubs &&
                                <LoadingPlaceholder isError={errorListHubs}/>
                            }
                        </div>

                    </div>
                </section>
    }
}

module.exports = CoverHub;
